import reactCSS from 'reactcss';
import {
  content,
  footnote,
} from '@ux/type-size';
import cssSides, { Side } from '@team-griffin/css-sides';
import { gu2px } from '@ux/theme-utils';

export default ({
  theme,
}) => {
  const {
    spacing,
    typography,
    palette,
  } = theme;

  return reactCSS({
    default: {
      info: {
        listStyle: 'none',
        ...cssSides('padding', Side.A, 0),
        ...cssSides('margin', Side.A, 0),
        marginBottom: gu2px(3, spacing),
        ...footnote(typography),
      },
      step: {
        display: 'flex',
        marginBottom: gu2px(2, spacing),
        alignItems: 'flex-start',
      },
      number: {
        ...content(typography),
        backgroundColor: palette.primary,
        color: palette.primaryContrast,
        minWidth: gu2px(5, spacing),
        minHeight: gu2px(5, spacing),
        borderRadius: gu2px(3, spacing),
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: gu2px(1, spacing),
      },
    },
  });
};
